export const PLACED_BOXES_FEATURE_KEY = 'placed-boxes';
